import React from 'react'
import PreCode from './PreCode'
import * as Home from './Home'
import * as ContentList from './ContentList'
import * as CacheUtils from '../util/CacheUtils'
import * as DataUtils from '../util/DataUtils'

export function resetCache() {
  const keys = [
    DataUtils.UPDATED,
    ContentList.AGGREGATES,
    Home.Q_CONTENTS,
    ContentList.SLUGS,
    `Post${ContentList.SLUGS}`,
    `P${ContentList.SLUGS}`,
    'Postundefined',
    'postslugs',
    'pslugs',
    'q_contents',
    'q_latest-posts',
    'q_problems',
  ]
  const out = []
  keys.forEach(key=>{
    CacheUtils.remove(key)
    out.push(`${key} -> ${CacheUtils.get(key)}`)
  })
  return out
}

export default class Reset extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      out: []
    }
  }
  componentDidMount() {
    this.setState({out:resetCache()})
  }
  render() {
    return (
      <div>
        <h1>Reset</h1>
        <PreCode
          value={this.state.out.map(e=>e)}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Reset.js